import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../../styles/Team.module.css';

const AffiliateLeaderboard = ({ leaderboard, currentUserId }) => {
  const getRankColor = (rank) => {
    switch (rank) {
      case 1: return styles.goldRank;
      case 2: return styles.silverRank;
      case 3: return styles.bronzeRank;
      default: return '';
    }
  };

  const getRankIcon = (rank) => {
    switch (rank) {
      case 1: return <FontAwesomeIcon icon="medal" style={{ color: '#FFD700' }} />;
      case 2: return <FontAwesomeIcon icon="medal" style={{ color: '#C0C0C0' }} />;
      case 3: return <FontAwesomeIcon icon="medal" style={{ color: '#CD7F32' }} />;
      default: return <span className={styles.rankNumber}>#{rank}</span>;
    }
  };

  return (
    <div className={styles.leaderboardContainer}>
      <div className={styles.leaderboardHeader}>
        <div className={styles.rankHeader}>
          <FontAwesomeIcon icon="trophy" style={{ marginRight: '6px', opacity: 0.7 }} />
          Rank
        </div>
        <div className={styles.nameHeader}>
          <FontAwesomeIcon icon="user" style={{ marginRight: '6px', opacity: 0.7 }} />
          Affiliate
        </div>
        <div className={styles.earningsHeader}>
          <FontAwesomeIcon icon="dollar-sign" style={{ marginRight: '6px', opacity: 0.7 }} />
          Earnings
        </div>
        <div className={styles.referralsHeader}>
          <FontAwesomeIcon icon="users" style={{ marginRight: '6px', opacity: 0.7 }} />
          Referrals
        </div>
      </div>
      
      <div className={styles.leaderboardList}>
        {leaderboard.map((affiliate) => (
          <div 
            key={affiliate.id}
            className={`${styles.leaderboardItem} ${affiliate.name === 'You' ? styles.currentUser : ''} ${getRankColor(affiliate.rank)}`}
          >
            <div className={styles.rankCell}>
              {getRankIcon(affiliate.rank)}
            </div>
            
            <div className={styles.nameCell}>
              <div className={styles.affiliateName}>
                {affiliate.name}
                {affiliate.name === 'You' && (
                  <span className={styles.youBadge}>
                    <FontAwesomeIcon icon="user" />
                    You
                  </span>
                )}
              </div>
            </div>
            
            <div className={styles.earningsCell}>
              <span className={styles.earningsAmount}>
                ${affiliate.earnings.toLocaleString()}
              </span>
            </div>
            
            <div className={styles.referralsCell}>
              <span className={styles.referralsCount}>
                {affiliate.referrals}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AffiliateLeaderboard; 